import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function stripLang(pathname) {
  // Removes the leading /ar or /en segment so that a pure language switch
  // does not trigger a scroll-to-top.
  return pathname.replace(/^\/(ar|en)(?=\/|$)/, "") || "/";
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevRef = useRef(stripLang(pathname));

  useEffect(() => {
    const stripped = stripLang(pathname);
    // If only the language segment changed, do not scroll
    if (stripped === prevRef.current) {
      prevRef.current = stripped;
      return;
    }
    prevRef.current = stripped;

    // If there is an in-page hash, let the browser handle it
    if (hash) return;

    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return null;
}
